module.exports = __webpack_public_path__ + "fonts/comfortaa-bold-webfont.4df9a04e.woff";